export default __webpack_public_path__ + "static/Resolve-BoldIta-790d3a0547eafbb9596135f167c933dc.woff2";